module.exports = __webpack_public_path__ + "static/media/studypurse.a4f29c7c.gif";